"use client";

import { Download } from "lucide-react";
import { Link } from "@/components/common/Link";
import { Badge } from "@/components/ui/badge";
import { Button } from "@/components/ui/button";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
export default function Hero() {
  const {
    ref,
    isVisible
  } = useRevealOnScroll<HTMLDivElement>();
  const steps = [{
    num: "1",
    label: "Understand your requirements"
  }, {
    num: "2",
    label: "Prepare and analyse the data"
  }, {
    num: "3",
    label: "Deliver clear insight"
  }];
  return <section data-section-id="6090" id="hero" className="relative overflow-hidden text-foreground py-24 md:py-32 dark bg-accent">
      {}
      <div aria-hidden="true" className="pointer-events-none absolute left-1/2 top-1/3 -z-0 -translate-x-1/2 -translate-y-1/2">
        <div className="h-[480px] w-[480px] rounded-lg blur-[70px] opacity-50" style={{
        background: "radial-gradient(circle, hsl(199 89% 48%) 0%, hsl(199 89% 48% / 0.6) 40%, transparent 70%)",
        animation: "sunDrift 22s ease-in-out infinite alternate"
      }} />
      </div>

      <style>{`
        @keyframes sunDrift {
          0% { transform: translate(0, 0); }
          100% { transform: translate(10px, 8px); }
        }
      `}</style>

      <div ref={ref} className="container relative z-10 mx-auto max-w-[980px] px-6 md:px-10 lg:px-16">
        <div className="flex flex-col items-center text-center">
          {}
          <div className="transition-all duration-700" style={{
          transitionTimingFunction: "cubic-bezier(0.22, 1, 0.36, 1)",
          opacity: isVisible ? 1 : 0,
          transform: isVisible ? "translateY(0)" : "translateY(24px)",
          transitionDelay: "0ms"
        }}>
            
          </div>

          {}
          <h1 className="mt-7 font-default font-medium tracking-tight text-foreground transition-all duration-700" style={{
          fontSize: "clamp(2.75rem, 6.2vw, 5.25rem)",
          lineHeight: "1.02",
          letterSpacing: "-0.02em",
          transitionTimingFunction: "cubic-bezier(0.22, 1, 0.36, 1)",
          opacity: isVisible ? 1 : 0,
          transform: isVisible ? "translateY(0)" : "translateY(24px)",
          transitionDelay: "90ms"
        }}>
            Start your{" "}
            <span className="italic !bg-transparent text-secondary-foreground" style={{
            color: "white"
          }}>From complex data to clear journey</span>
          </h1>

          {}
          <p className="mx-auto mt-6 max-w-[600px] font-default text-muted-foreground transition-all duration-700" style={{
          fontSize: "clamp(1.125rem, 1.4vw, 1.375rem)",
          lineHeight: "1.55",
          letterSpacing: "-0.005em",
          transitionTimingFunction: "cubic-bezier(0.22, 1, 0.36, 1)",
          opacity: isVisible ? 1 : 0,
          transform: isVisible ? "translateY(0)" : "translateY(24px)",
          transitionDelay: "180ms"
        }}>A practical, structured approach that turns raw information into reliable reports, meaningful insights, and better business understanding.</p>

          {}
          <div className="mt-12 flex flex-col items-center gap-6 transition-all duration-700 sm:flex-row sm:flex-wrap sm:justify-center sm:gap-8" style={{
          transitionTimingFunction: "cubic-bezier(0.22, 1, 0.36, 1)",
          opacity: isVisible ? 1 : 0,
          transform: isVisible ? "translateY(0)" : "translateY(24px)",
          transitionDelay: "270ms"
        }}>
            {steps.map((step, i) => <div key={step.num} data-index={i} className="flex items-center gap-3">
                <div className="flex h-10 w-10 items-center justify-center rounded-lg font-default font-semibold text-secondary bg-card" style={{
              backgroundColor: "hsl(199 89% 48% / 0.12)",
              color: "var(--primary)"
            }}>
                  {step.num}
                </div>
                <span className="font-default text-[14px] font-medium text-muted-foreground">
                  {step.label}
                </span>
              </div>)}
          </div>

          {}
          <div className="mt-12 flex w-full flex-col items-center justify-center gap-4 transition-all duration-700 sm:w-auto sm:flex-row" style={{
          transitionTimingFunction: "cubic-bezier(0.22, 1, 0.36, 1)",
          opacity: isVisible ? 1 : 0,
          transform: isVisible ? "translateY(0)" : "translateY(24px)",
          transitionDelay: "360ms"
        }}>
            <Button asChild size="lg" className="h-auto w-full rounded-lg bg-primary px-7 py-3.5 font-default text-base font-semibold text-primary-foreground shadow-lg hover:bg-primary/90 hover:scale-[1.04] sm:w-auto" style={{
            transitionTimingFunction: "cubic-bezier(0.34, 1.56, 0.64, 1)",
            transitionDuration: "240ms"
          }}>
              <Link to="/OurServicesPage">Explore Our Capabilities</Link>
            </Button>
            <Button asChild variant="outline" size="lg" className="h-auto w-full rounded-lg border-[1.5px] border-foreground bg-transparent px-7 py-3.5 font-default text-base font-semibold text-foreground hover:bg-foreground hover:text-background sm:w-auto" style={{
            transitionDuration: "220ms"
          }}>
              
            </Button>
          </div>
        </div>
      </div>
    </section>;
}